import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function BonusSection() {
  const bonuses = [{
    badge: 'BONUS 01',
    title: 'Planificador Semanal Docente "Cero Estrés"',
    subtitle: '"Organizá tus 5 días en una sola hoja"',
    desc: 'Plantillas de horario semanal, organizador de tareas por escuela, lista de prioridades y checklist de cierre de semana. Eliminá la ansiedad del domingo a la noche para siempre.',
    value: 'Valor $12.000',
    img: 'https://images.unsplash.com/photo-1506784983877-45594efa4cbe?auto=format&fit=crop&q=80&w=600'
  }, {
    badge: 'BONUS 02',
    title: 'Plantillas de Seguimiento de Alumnos y Asistencia',
    subtitle: '"Control total de tus 200+ alumnos"',
    desc: 'Registro de asistencia mensual (2 modelos), planilla de entrega de TPs, ficha de observación individual, registro de notas y planilla de alumnos en riesgo.',
    value: 'Valor $10.000',
    img: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&q=80&w=600'
  }, {
    badge: 'BONUS 03',
    title: 'Guía de Comunicación con Familias y Directivos',
    subtitle: '"Plantillas listas para copiar y pegar"',
    desc: '7 modelos listos: citación a padres, informe de bajo rendimiento, informe de convivencia, nota de felicitación, acta de reunión y comunicados. Ahorrá horas de redacción.',
    value: 'Valor $9.000',
    img: 'https://images.unsplash.com/photo-1577563908411-5077b6dc7624?auto=format&fit=crop&q=80&w=600'
  }, {
    badge: 'BONUS 04',
    title: 'Banco Express de Actividades de Emergencia',
    subtitle: '"Resolvé cualquier clase imprevista en 2 minutos"',
    desc: '20 disparadores de debate, actividades de 5 a 20 minutos, análisis de noticias flash, dinámicas sin fotocopias y cierres rápidos. Para cuando no llegaste a planificar.',
    value: 'Valor $8.000',
    img: 'https://images.unsplash.com/photo-1584697964190-7388c2f82f12?auto=format&fit=crop&q=80&w=600'
  }, {
    badge: 'BONUS 05',
    title: 'Kit de Actos y Efemérides — Versión Ciudadanía',
    subtitle: '"Fechas patrias con enfoque ciudadano real"',
    desc: 'Material listo para el 24 de marzo, 2 de abril, 25 de mayo, 20 de junio, 9 de julio y más. Con texto de lectura, preguntas de reflexión y actividad lista para cada fecha.',
    value: 'Valor $7.000',
    img: 'https://images.unsplash.com/photo-1532372320572-cda25653a26d?auto=format&fit=crop&q=80&w=600'
  }, {
    badge: 'BONUS 06',
    title: 'Guía "Cero Presupuesto" — Clases sin Recursos',
    subtitle: '"Clases brillantes sin Wi-Fi, proyector ni libros"',
    desc: 'Dinámicas con el cuerpo y el espacio, debates sin tecnología, juegos ciudadanos sin materiales y proyectos con materiales de descarte. Para la escuela argentina real.',
    value: 'Valor $9.000',
    img: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?auto=format&fit=crop&q=80&w=600'
  }];
  return <section className="py-20 bg-brand-50" data-id="element-16">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-17">
        <div className="text-center mb-16" data-id="element-18">
          <div className="inline-flex items-center gap-2 bg-amber-100 text-amber-800 px-6 py-2 rounded-full font-bold text-sm mb-6 uppercase tracking-wider" data-id="element-19">
            <Gift className="w-5 h-5" data-id="element-20" /> Gratis por el día de hoy
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mb-4" data-id="element-21">
            Más los 6 Regalos Estratégicos
          </h2>
          <p className="text-xl text-brand-600 font-medium" data-id="element-22">
            Incluidos en todas las ofertas — sin costo extra
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-23">
          {bonuses.map((bonus, i) => <motion.div key={i} whileHover={{
          y: -5
        }} className="bg-white rounded-2xl overflow-hidden shadow-lg border border-slate-100 flex flex-col" data-id="element-24">
              <div className="h-48 relative bg-slate-200" data-id="element-25">
                <img src={bonus.img} alt={bonus.title} className="w-full h-full object-cover" data-id="element-26" />
                <div className="absolute top-4 left-4 bg-brand-900 text-white text-xs font-bold px-3 py-1 rounded-md" data-id="element-27">
                  {bonus.badge}
                </div>
              </div>
              <div className="p-6 flex flex-col flex-1" data-id="element-28">
                <h3 className="text-xl font-bold text-slate-900 mb-2 leading-tight" data-id="element-29">
                  {bonus.title}
                </h3>
                <h4 className="text-sm font-bold text-brand-600 mb-4" data-id="element-30">
                  {bonus.subtitle}
                </h4>
                <p className="text-slate-600 text-sm mb-6 flex-1" data-id="element-31">
                  {bonus.desc}
                </p>

                <div className="flex items-center justify-between pt-4 border-t border-slate-100 mt-auto" data-id="element-32">
                  <span className="text-slate-400 line-through text-sm" data-id="element-33">
                    {bonus.value}
                  </span>
                  <span className="text-green-600 font-bold flex items-center gap-1" data-id="element-34">
                    → GRATIS
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}